namespace advisorop.components.advisor {

    export class CuInvestorController {       
        //bindings     
        investor: domains.IInvestor;
        working: boolean = false;
        onCreate: any;
        onUpdate: any;
        onCancel: any;
        onInitialised: any;

        //regular properties
        lovs: Array<domains.ILOV> = [];
        selGender: domains.ILOV;
        selMaritalStatus: domains.ILOV;
        investorMaritalStatus: domains.ILOV[] = [];
        selCitizenship: domains.ILOV;
        selMailingCountry: domains.ILOV;
        selStreetCountry: domains.ILOV;
        selLegalTaxResidence: domains.ILOV;
        citizenships: domains.ILOV[] = [];
        selMailingState: domains.ILOV;
        selStreetState: domains.ILOV;
        selEmployerState: domains.ILOV;
        states: domains.ILOV[] = [];
        investorGenders: Array<domains.ILOV> = [];
        //advisors: Array<domains.IInvestorAdvisor> = [];
        selEmploymentStatus: domains.ILOV;
        investorEmploymentStatuses: Array<domains.ILOV> = [];
        selEmployerCountry: domains.ILOV;
        selUSCitizenshipStatus: domains.ILOV;
        investorUSCitizenshipStatuses: Array<domains.ILOV> = [];
        
        entityTypes: domains.ILOV[] = [];
        selEntityType: domains.ILOV;

        trustTypes: domains.ILOV[] = [];
        selTrustType: domains.ILOV;

        // investor login options
        loginOptionTypes: domains.ILOV[] = [];
        showSleeves: boolean = false;
        showPointToPoint: boolean = false;
        showHistAssetAllocChartsGroups: boolean = false;
        showHistAssetAllocChartsAccts: boolean = false;
        landingPageTypes: domains.ILOV[] = [];
        landingPage: domains.ILOV;
        landingPageValue: string;
        household: domains.IHousehold;
   
        dxTrustDate: DevExpress.ui.dxDateBoxOptions;
        dxTrustDateValidator: DevExpress.ui.dxValidatorOptions;
        dxEmpStartDate: DevExpress.ui.dxDateBoxOptions;
        dxEmpStartDateValidator: DevExpress.ui.dxValidatorOptions;

        StateFormat = domains.StateFormat;

        flagForCreate: boolean = true;
        streetAddressSameAsMailingAddress: boolean = false;
        set typeStreetState(value: boolean) {
            this.investor.streetStateFormat = value ? domains.StateFormat.RAW_TEXT : domains.StateFormat.TWO_DIGIT_CODE;
        } get typeStreetState(): boolean {
            return this.investor && (this.investor.streetStateFormat == domains.StateFormat.RAW_TEXT);
        }
        set typeMailingState(value: boolean) {
            this.investor.mailingStateFormat = value ? domains.StateFormat.RAW_TEXT : domains.StateFormat.TWO_DIGIT_CODE;
        } get typeMailingState(): boolean {
            return this.investor && (this.investor.mailingStateFormat == domains.StateFormat.RAW_TEXT);
        }
        set typeEmployerState(value: boolean) {
            this.investor.employerStateFormat = value ? domains.StateFormat.RAW_TEXT : domains.StateFormat.TWO_DIGIT_CODE;
        } get typeEmployerState(): boolean {
            return this.investor && (this.investor.employerStateFormat == domains.StateFormat.RAW_TEXT);
        }
        investorIsUnemployed: boolean = false;
        forceUSCitizenship: boolean = false;
        usCountryCode: string = "US";

        static $inject = ["advisorService", "$scope", "generalService", "identityService"];
        constructor(
            private advisorService: services.AdvisorService,
            private $scope: ng.IScope,
            private generalService: services.GeneralService,
            private identityService: services.IdentityService) {
            this.investor = {
                useEmailAsUsername: true,
            };

            this.investorIsUnemployed = false;

            this.dxTrustDate = {
                type: "date",
                invalidDateMessage: "Trust date is required",
                validationMessageMode: "always",
                width: "100%",
                bindingOptions: {
                    value: "vm.investor.trustDate"
                }
            };
            this.dxTrustDateValidator = {
                validationRules: [
                    {type:"required", message:"Trust Date is required" }
                ]
            };

            this.dxEmpStartDate = {
                readOnly: this.investorIsUnemployed,
                disabled: this.investorIsUnemployed,
                bindingOptions: {
                    value: "vm.investor.employmentStartDate"
                }
            };

            //Not sure yet if this should be required...
            //this.dxEmpStartDateValidator = {
            //    validationRules: [
            //        { type: "required", message: "Employment Start Date is required" }
            //    ]
            //};
        }

        bindInvestor(): void {
            //console.log('binding investors');

            this.selGender = <domains.ILOV>{ value: this.investor.gender };
            this.selMaritalStatus = <domains.ILOV>{ value: this.investor.maritalStatus };

            this.selEntityType = <domains.ILOV>{ value: this.investor.entityType };
            this.selTrustType = <domains.ILOV>{ value: this.investor.trustType };

            this.selCitizenship = <domains.ILOV>{ extra2: this.investor.citizenship };
            this.selStreetCountry = <domains.ILOV>{ extra2: this.investor.streetCountryId };
            this.selMailingCountry = <domains.ILOV>{ extra2: this.investor.mailingCountryId };
            this.selLegalTaxResidence = <domains.ILOV>{ extra2: this.investor.legalTaxResidence };

            // If the string coming from the DB matches a LOV entry, then set the value from the LOV entry and use the dropdown widget.
            // Otherwise, the user has entered a string, so use the string and clear out the LOV association.
            // this exists so that the user can enter a Province (case where they are Canadian, which the Pershing app allows.).
            if (!this.investor.streetState) {
                this.selStreetState = null;
            } else {
                var sstate = this.states.filter(v => v.extra1 === this.investor.streetState);
                if (sstate.length > 0) {
                    this.selStreetState = sstate[0];
                } else {
                    this.selStreetState = null;
                }
            }

            // If the database value is not set, then set the typeMailingState to default of FALSE.
            // If the string coming from the DB matches a LOV entry, then set the value from the LOV entry and use the dropdown widget.
            // Otherwise, the user has entered a string, so use the string and clear out the LOV association.
            // this exists so that the user can enter a Province (case where they are Canadian, which the Pershing app allows.).
            if (!this.investor.mailingState) {
                // this.typeMailingState = false;
                this.selMailingState = null;
            } else {
                var mstate = this.states.filter(v => v.extra1 === this.investor.mailingState);
                if (mstate.length > 0) {
                    // this.typeMailingState = false;
                    this.selMailingState = mstate[0];
                } else {
                    // this.typeMailingState = true;
                    this.selMailingState = null;
                }
            }

            // If the string coming from the DB matches a LOV entry, then set the value from the LOV entry and use the dropdown widget.
            // Otherwise, the user has entered a string, so use the string and clear out the LOV association.
            // this exists so that the user can enter a Province (case where they are Canadian, which the Pershing app allows.).
            if (!this.investor.employerState) {
                // this.typeEmployerState = false;
                this.selEmployerState = null;
            } else {
                var estate = this.states.filter(v => v.extra1 === this.investor.employerState);
                if (estate.length > 0) {
                    // this.typeEmployerState = false;
                    this.selEmployerState = estate[0];
                } else {
                    // this.typeEmployerState = true;
                    this.selEmployerState = null;
                }
            }

            // If country is US, then state must be set via dropdown, we need to force the state
            // to be the 2-character state code.
            //if (this.selStreetCountry != null && this.selStreetCountry.extra2 == this.usCountryCode)
            //    this.typeStreetState = false;
            //if (this.selMailingCountry != null && this.selMailingCountry.extra2 == this.usCountryCode)
            //    this.typeMailingState = false;
            //if (this.selEmployerCountry != null && this.selEmployerCountry.extra2 == this.usCountryCode)
            //    this.typeEmployerState = false;

            // No longer bind this field from the server... we do not have a way of syncing this value to Salesforce,
            // so even if we have it set in the database, the 2 addresses could be different coming from
            // Salesforce, and we could end up having 2 different addresses even if we have set this attribute.
            // So, we will only use this attribute locally on the GUI to copy the address fields from Legal -> Mailing
            // as a convenience for the user.
            //this.streetAddressSameAsMailingAddress = this.investor.streetAddressSameAsMailingAddress;
            
            this.selEmploymentStatus = <domains.ILOV>{ value: this.investor.employmentStatus };
            this.selEmployerCountry = <domains.ILOV>{ extra2: this.investor.employerCountryId };
            this.selUSCitizenshipStatus = <domains.ILOV>{ value: this.investor.usCitizenshipStatus };

            if (this.selUSCitizenshipStatus.value == domains.USCitizenStatus.US_CITIZEN)
                this.forceUSCitizenship = true;
            else
                this.forceUSCitizenship = false;

            if (this.selEmploymentStatus.value == domains.EmploymentStatus.EMPLOYED || this.selEmploymentStatus.value == domains.EmploymentStatus.SELF_EMPLOYED)
                this.investorIsUnemployed = false;
            else
                this.investorIsUnemployed = true;
            
            //we need to move this outside of cu-investor...
            this.advisorService.getAdvisorsForInvestor(this.investor.id)
                .then(data => {
                    var allAdvisors = data.data as domains.IInvestorAdvisor[];
                    this.investor.advisors = allAdvisors.filter(a => a.relationType == domains.RelationType.PRIMARY);
                    this.investor.secondaryAdvisors = allAdvisors.filter(a => a.relationType == domains.RelationType.SECONDARY);
                })
                .catch(err => {
                    toastr.error("Unable to fetch advisors for this individual!");
                });

            // bind login options
            var landingPageValue: number;
            if (this.investor.loginOptions && this.investor.loginOptions.length > 0) {
                var landingPageType: domains.LandingPage = domains.LandingPage.DASHBOARD;
                this.investor.loginOptions.forEach(option => {
                    switch (option.type) {
                        case domains.LovType.INVESTOR_LOGIN_OPTION_TYPE: {
                            switch (option.option) {
                                case domains.InvestorLoginOption.SHOW_SLEEVES: {
                                    this.showSleeves = option.value == 1;
                                    break;
                                }
                                case domains.InvestorLoginOption.SHOW_POINT_TO_POINT_PERFORMANCE: {
                                    this.showPointToPoint = option.value == 1;
                                    break;
                                }
                                case domains.InvestorLoginOption.LANDING_PAGE: {
                                    landingPageType = option.value;
                                    break;
                                }
                                case domains.InvestorLoginOption.SHOW_HISTORICAL_ASSET_ALLOC_CHARTS_GROUPLEVEL: {
                                    this.showHistAssetAllocChartsGroups = option.value == 1;
                                    break;
                                }
                                case domains.InvestorLoginOption.SHOW_HISTORICAL_ASSET_ALLOC_CHARTS_ACCTLEVEL: {
                                    this.showHistAssetAllocChartsAccts = option.value == 1;
                                    break;
                                }
                                default: {
                                    break;
                                }
                            }
                            break;
                        }
                        case domains.LovType.INVESTOR_LOGIN_LANDING_PAGE_TYPE: {
                            landingPageValue = option.value;
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                })
                this.landingPage = this.landingPageTypes.filter(lp => lp.value == landingPageType)[0]
            }
            if (this.investor.households && this.investor.households.length > 0) {
                this.household = this.investor.households.filter(hh => hh.id == landingPageValue).length > 0 ? this.investor.households.filter(hh => hh.id == landingPageValue)[0] : this.investor.households[0];
            } 
        };
        
        reset(): void {
            this.investor = {};
            this.investor.gender = undefined;
            this.investor.investorType = undefined;
            this.investor.maritalStatus = undefined;
            this.investor.employmentStatus = undefined;
            this.investor.usCitizenshipStatus = undefined;
            this.investor.streetState = undefined;
            this.investor.mailingState = undefined;
            this.investor.employerState = undefined;
            this.investor.vulnerableAdult = false;
            this.streetAddressSameAsMailingAddress = false;
            this.typeStreetState = false;
            this.typeMailingState = false;
            this.typeEmployerState = false;
            this.investorIsUnemployed = false;

            var frm = <ng.IFormController>this.$scope["frmInvestor"];
            frm.$setPristine();
            frm.$setUntouched();
        };
        
        validateInvestorForm(): boolean {
            let valid = this.generalService.validateForm(<ng.IFormController>this.$scope["frmInvestor"]);
            if (!valid) {
                toastr.warning("Please enter all required fields and enter valid data.");
            }
            
            if (!this.investor.tin) {
                toastr.warning("Please provide TIN/SSN.");
                valid=false;
            };
            if (this.typeStreetState && !this.investor.streetState) {
                toastr.warning("Please provide Legal Address State.");
                valid = false;
            }
            if (!this.typeStreetState && !this.selStreetState) {
                toastr.warning("Please select Legal Address State.");
                valid = false;
            }
            if (this.typeMailingState && !this.investor.mailingState) {
                toastr.warning("Please provide Mailing Address State.");
                valid = false;
            }
            if (!this.typeMailingState && !this.selMailingState) {
                toastr.warning("Please select Mailing Address State.");
                valid = false;
            }
            if (this.investor.investorType == domains.InvestorType.INDIVIDUAL) {
                if (!this.investor.dateOfBirth) {
                    toastr.warning("Please provide Date of Birth.");
                    valid = false;
                };
                //if (!this.investorIsUnemployed && !this.investor.employmentStartDate) {
                //    toastr.warning("Please provide Employment Start Date.");
                //    valid = false;
                //};
                //if (!this.investorIsUnemployed && this.typeEmployerState && !this.investor.employerState) {
                //    toastr.warning("Please provide Employer Address State.");
                //    valid = false;
                //}
                //if (!this.investorIsUnemployed && !this.typeEmployerState && !this.selEmployerState) {
                //    toastr.warning("Please select Employer Address State.");
                //    valid = false;
                ///}
            }            
            return valid;
        };

        investorCreatedOrUpdated(investor: domains.IInvestor): void {
            if (investor.vulnerableAdult) {
                this.$scope.$broadcast('saveTrustedContacts', investor);
            }
        }

        createInvestor(): void {            
            if (!this.validateInvestorForm()) {
                return;
            };

            if (this.selEntityType)
                this.investor.entityType = this.selEntityType.value;
            if (this.selGender)
                this.investor.gender = this.selGender.value;
            if (this.selMaritalStatus)
                this.investor.maritalStatus = this.selMaritalStatus.value;
            if (this.selCitizenship)
                this.investor.citizenship = this.selCitizenship.extra2;
            if (this.selStreetCountry)
                this.investor.streetCountryId = this.selStreetCountry.extra2;
            if (this.selMailingCountry)
                this.investor.mailingCountryId = this.selMailingCountry.extra2;
            if (this.selLegalTaxResidence)
                this.investor.legalTaxResidence = this.selLegalTaxResidence.extra2;


            if (!this.typeMailingState) {
                // if nothing selected then model must be set to NULL
                this.investor.mailingState = this.selMailingState ? this.selMailingState.extra1 || null : null;
            }
            if (!this.typeStreetState) {
                this.investor.streetState = this.selStreetState ? this.selStreetState.extra1 || null : null;
            }
            if (!this.typeEmployerState) {
                this.investor.employerState = this.selEmployerState ? this.selEmployerState.extra1 || null : null;
            }


            if (this.selEmploymentStatus)
                this.investor.employmentStatus = this.selEmploymentStatus.value;
            if (this.selEmployerCountry)
                this.investor.employerCountryId = this.selEmployerCountry.extra2;
            if (this.selUSCitizenshipStatus)
                this.investor.usCitizenshipStatus = this.selUSCitizenshipStatus.value;
            
            // //////////////////////////////////
            // COMPANY investors special rules
            if (this.investor.investorType == domains.InvestorType.COMPANY) {
                this.investor.entityType = this.selEntityType.value;
                if (this.investor.entityType == domains.EntityType.TRUST) {
                    this.investor.trustType = this.selTrustType.value;
                }
                else {
                    this.investor.trustDate = null;
                    this.investor.trustType = null;
                }
            }
            else {
                this.investor.trustDate = null;
                this.investor.trustType = null;
                this.investor.entityName = null;
                this.investor.entityType = null;
            }
            // ////////////////////////////////////
            
            //this.investor.id = 0;
            this.investor.companyGroup = null;

            // We will link this advisor to the investor as PRIMARY by default when creating this investor on the server
            this.investor.advisors = [];
            this.investor.secondaryAdvisors = [];

            if (this.investor.investorType == domains.InvestorType.INDIVIDUAL) {
                //for individuals name should be the same
                this.investor.contactFirstName = this.investor.firstName;
                this.investor.contactLastName = this.investor.lastName;
            };

            this.investor.streetAddressSameAsMailingAddress = this.streetAddressSameAsMailingAddress;

            if (this.onCreate) {
                let eventData: domains.IInvestor = {}
                angular.copy(this.investor, eventData);
                this.onCreate({ investor: eventData });
            };                       
        }
        
        updateInvestor(): void {

            if (!this.validateInvestorForm()) {
                return;
            };

            if (this.selEntityType)
                this.investor.entityType = this.selEntityType.value;
            if (this.selGender)
                this.investor.gender = this.selGender.value;
            if (this.selMaritalStatus)
                this.investor.maritalStatus = this.selMaritalStatus.value;
            if (this.selCitizenship)
                this.investor.citizenship = this.selCitizenship.extra2;
            if (this.selStreetCountry)
                this.investor.streetCountryId = this.selStreetCountry.extra2;
            if (this.selMailingCountry)
                this.investor.mailingCountryId = this.selMailingCountry.extra2;
            if (this.selLegalTaxResidence)
                this.investor.legalTaxResidence = this.selLegalTaxResidence.extra2;
            if (!this.typeMailingState) {
                // if nothing selected then model must be set to NULL
                this.investor.mailingState = this.selMailingState ? this.selMailingState.extra1 || null : null;
            }
            if (!this.typeStreetState) {
                this.investor.streetState = this.selStreetState ? this.selStreetState.extra1 || null : null;
            }
            if (!this.typeEmployerState) {
                this.investor.employerState = this.selEmployerState ? this.selEmployerState.extra1 || null : null;
            }
            if (this.selEmploymentStatus)
                this.investor.employmentStatus = this.selEmploymentStatus.value;
            if (this.selEmployerCountry)
                this.investor.employerCountryId = this.selEmployerCountry.extra2;
            if (this.selUSCitizenshipStatus)
                this.investor.usCitizenshipStatus = this.selUSCitizenshipStatus.value;

            // //////////////////////////////////
            // COMPANY investors special rules
            if (this.investor.investorType == domains.InvestorType.COMPANY) {
                this.investor.entityType = this.selEntityType.value;
                if (this.investor.entityType == domains.EntityType.TRUST) {
                    this.investor.trustType = this.selTrustType.value;
                }
                else {
                    this.investor.trustDate = null;
                    this.investor.trustType = null;
                }
            }
            else {
                this.investor.trustDate = null;
                this.investor.trustType = null;
                this.investor.entityName = null;
                this.investor.entityType = null;
            }
            // ////////////////////////////////////
            
            this.investor.streetAddressSameAsMailingAddress = this.streetAddressSameAsMailingAddress;

            var householdId = 0;
            if (this.household != undefined) {
                householdId = this.household.id;
            }

            // update login options
            this.updateAddLoginOption(domains.LovType.INVESTOR_LOGIN_OPTION_TYPE, domains.InvestorLoginOption.SHOW_SLEEVES, this.showSleeves ? 1 : 0);
            this.updateAddLoginOption(domains.LovType.INVESTOR_LOGIN_OPTION_TYPE, domains.InvestorLoginOption.SHOW_POINT_TO_POINT_PERFORMANCE, this.showPointToPoint ? 1 : 0);
            this.updateAddLoginOption(domains.LovType.INVESTOR_LOGIN_OPTION_TYPE, domains.InvestorLoginOption.LANDING_PAGE, this.landingPage.value);
            this.updateAddLoginOption(domains.LovType.INVESTOR_LOGIN_LANDING_PAGE_TYPE, this.landingPage.value, this.landingPage.value == domains.LandingPage.DASHBOARD ? 0 : householdId);
            this.updateAddLoginOption(domains.LovType.INVESTOR_LOGIN_OPTION_TYPE, domains.InvestorLoginOption.SHOW_HISTORICAL_ASSET_ALLOC_CHARTS_GROUPLEVEL, this.showHistAssetAllocChartsGroups ? 1 : 0);
            this.updateAddLoginOption(domains.LovType.INVESTOR_LOGIN_OPTION_TYPE, domains.InvestorLoginOption.SHOW_HISTORICAL_ASSET_ALLOC_CHARTS_ACCTLEVEL, this.showHistAssetAllocChartsAccts ? 1 : 0);

            let eventData: domains.IInvestor = {}
            angular.copy(this.investor, eventData);
            this.onUpdate({ investor: eventData });
        };

        cancel(): void {
            if (this.onCreate) {
                this.onCancel();
            };
        };

        updateAddLoginOption(type: domains.LovType, option: number, value: number) {
            if (this.investor.loginOptions.filter(o => o.type == type && o.option == option).length == 0) {
                this.investor.loginOptions.push({
                    type: type,
                    option: option,
                    value: value
                });
                return;
            }
            this.investor.loginOptions.filter(o => o.type == type && o.option == option)[0].value = value;
        }
        
        //flagForZipField: boolean = false;
        
        streetAddressChanged(): void {

            //console.log('street address changed...');
            if (this.selStreetCountry != null && this.selStreetCountry.extra2 == this.usCountryCode)
                this.typeStreetState = false;
            if (this.selMailingCountry != null && this.selMailingCountry.extra2 == this.usCountryCode)
                this.typeMailingState = false;

            if (this.typeStreetState)
                this.selStreetState = null;
            if (this.typeMailingState)
                this.selMailingState = null;

            if (this.streetAddressSameAsMailingAddress == true) {
                this.investor.mailingAddress1 = this.investor.streetAddress1;
                this.investor.mailingAddress2 = this.investor.streetAddress2;
                this.investor.mailingCity = this.investor.streetCity;
                this.investor.mailingCountryId = this.investor.streetCountryId;
                this.investor.mailingPostCode = this.investor.streetPostCode
                this.investor.mailingState = this.investor.streetState;
                this.selMailingCountry = angular.copy(this.selStreetCountry);
                this.selMailingState = angular.copy(this.selStreetState);
                this.typeMailingState = this.typeStreetState;
            }
        }

        employerAddressChanged(): void {
            if (this.selEmployerCountry != null && this.selEmployerCountry.extra2 == this.usCountryCode)
                this.typeEmployerState = false;
            if (this.typeEmployerState)
                this.selEmployerState = null;
        }

        mailingAddressChanged(): void {
            if (this.selMailingCountry != null && this.selMailingCountry.extra2 == this.usCountryCode)
                this.typeMailingState = false;
            if (this.typeMailingState)
                this.selMailingState = null;
        }

        citizenshipChanged(): void {
            // If US Citizen cititzenship status is selected, set the country of citizenship to United States.
            if (this.selUSCitizenshipStatus.value == domains.USCitizenStatus.US_CITIZEN) {
                this.selCitizenship = this.citizenships.filter(v => v.extra2 === this.usCountryCode)[0];
                this.forceUSCitizenship = true;
            }
            else {
                this.forceUSCitizenship = false;
            }
        }

        equalsAddresses(): void {
            this.streetAddressSameAsMailingAddress = !this.streetAddressSameAsMailingAddress;
            //this.flagForZipField = !this.flagForZipField;
            this.streetAddressChanged();
        }

        empStatusChanged(): void {
            if (this.selEmploymentStatus.value == domains.EmploymentStatus.EMPLOYED || this.selEmploymentStatus.value == domains.EmploymentStatus.SELF_EMPLOYED)
                this.investorIsUnemployed = false;
            else {
                this.investorIsUnemployed = true;
                this.investor.employerName = null;
                this.investor.employmentStartDate = null;
                this.investor.occupation = null;
                this.investor.employerAddress1 = null;
                this.investor.employerAddress2 = null;
                this.investor.employerCity = null;
                this.selEmployerState = null;
                this.investor.employerState = null;
                this.investor.employerPostCode = null;
                this.selEmployerCountry = null;
                this.investor.employerCountryId = null;
            }
        }

        //Loading LOVs for gender and Marital status, etc.
        loadLovs(): void {
            this.generalService.getLOVs()
                .then((data) => {
                    this.lovs = data;
                    this.investorMaritalStatus = this.lovs.filter(v => v.lovType == domains.LovType.MARITAL_STATUS);
                    //this.citizenships = this.lovs.filter(v => v.lovType === domains.LovType.COUNTRIES);
                    // Put US as first country in the list to make it more efficient to select
                    this.citizenships = this.lovs.filter(v => v.lovType === domains.LovType.COUNTRIES && v.extra2 === this.usCountryCode)
                        .concat(this.lovs.filter(v => v.lovType === domains.LovType.COUNTRIES && v.extra2 !== this.usCountryCode));
                    this.states = this.lovs.filter(v => v.lovType === domains.LovType.STATES);
                    this.investorGenders = this.lovs.filter(v => v.lovType === domains.LovType.GENDER);
                    this.entityTypes = this.lovs.filter(v => v.lovType == domains.LovType.ENTITY_TYPE);
                    this.trustTypes = this.lovs.filter(v => v.lovType == domains.LovType.TRUST_TYPE);
                    this.investorUSCitizenshipStatuses = this.lovs.filter(v => v.lovType === domains.LovType.US_CITIZEN_STATUS);
                    this.investorEmploymentStatuses = this.lovs.filter(v => v.lovType === domains.LovType.EMPLOYMENT_STATUS);
                    this.loginOptionTypes = this.lovs.filter(v => v.lovType === domains.LovType.INVESTOR_LOGIN_OPTION_TYPE);
                    this.landingPageTypes = this.lovs.filter(v => v.lovType === domains.LovType.INVESTOR_LOGIN_LANDING_PAGE_TYPE);
                    this.landingPage = this.landingPageTypes.filter(v => v.value == domains.LandingPage.HOUSEHOLD_DASHBOARD)[0];
                    // Default employment status to Unknown for new investor
                    if (!this.investor || !this.investor.id) {
                        this.selEmploymentStatus = this.lovs.filter(v => v.lovType === domains.LovType.EMPLOYMENT_STATUS && v.value == domains.EmploymentStatus.UNKNOWN)[0];
                        this.empStatusChanged();
                    }    
                    if (this.onInitialised) this.onInitialised({ me: this });
                }, (reason) => {
                    toastr.error("Error " + reason);
                });
        };

        $onInit(): void {            
            this.loadLovs();
        }

        $onChanges(evt): void {
            for (var key in evt) {
                if (key === "investor") {
                    if (this.investor && this.investor.id > 0) {
                        this.bindInvestor();
                    };
                }
            }
        }
        
    }


class CuInvestor implements ng.IComponentOptions {
    public bindings: any;
    public controller: any;
    public controllerAs: string;
    public templateUrl: string;

    constructor() {
        this.controller = CuInvestorController;
        this.controllerAs = "vm";
        this.bindings = {
            investor: "<",
            onCreate: "&",
            onUpdate: "&",
            onCancel: "&",
            onInitialised: "&"
        };
        this.templateUrl = "spa/shared/common/cu-investor.html";
    }

}
angular.module(Constants.APP).component("cuInvestor", new CuInvestor());


}